import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { LeiterListView } from './list-view/leiter.list-view';

export const leiterFieldOk: FieldOkConfig = {
  name: 'leiter',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{persnr}} - {{kurzbez}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: LeiterListView,
        sort: {
          properties: [{ property: 'persnr', title: 'Personalnummer' }],
        },
      },
    },
  ],
};

export const leiterMultiselectFieldOk: FieldOkConfig = {
  name: 'leiter',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{persnr}} - {{kurzbez}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: LeiterListView,
        sort: {
          properties: [{ property: 'persnr', title: 'Personalnummer' }],
        },
      },
    },
  ],
};

export const leiterQueryFieldOk: FieldOkConfig = {
  name: 'leiter',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{persnr}} - {{kurzbez}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: LeiterListView,
        sort: {
          properties: [{ property: 'persnr', title: 'Personalnummer' }],
        },
      },
    },
  ],
};
